import { useState } from "react";
import { IoChevronBack, IoSearchOutline } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import SelectedContact from "../Contacts/SelectedContact";
import ContactList from "../Contacts/ContactList";
import TextTranslate from "../../../utils/TextTranslate";
import { useTranslateText } from "../../../hooks/useTranslateText";
import { useAppSelector } from "../../../utils/hooks";

export default function AddMemberToGroup() {
  const [searchUser, setsearchUser] = useState("");
  const translate = useTranslateText();
  const navigate = useNavigate();
  const CreateGroup = useAppSelector((state) => state.CreateGroup);
  const canContinue = CreateGroup.user_id.length > 1;

  return (
    <div className="relative flex h-[100dvh] w-full flex-col overflow-hidden bg-secondary pb-[calc(3.25rem+env(safe-area-inset-bottom))] shadow-inner lg:max-w-md lg:pb-0">
      <div className="sticky top-0 z-20 shrink-0 border-b border-black/[0.06] bg-secondary/85 backdrop-blur-xl dark:border-white/[0.08]">
        <div className="flex items-center justify-between px-3 py-3">
          <button
            type="button"
            aria-label="Back"
            className="grid h-9 w-9 place-content-center rounded-full bg-black/[0.06] text-darkText transition active:scale-95 dark:bg-white/10"
            onClick={() => navigate(-1)}
          >
            <IoChevronBack className="text-xl" />
          </button>
          <span className="max-w-[14rem] truncate text-center text-[17px] font-semibold tracking-tight text-darkText">
            <TextTranslate text="Add Group Members" />
          </span>
          <div className="h-9 w-9" aria-hidden />
        </div>

        <div className="px-4 pb-3">
          <div className="relative">
            <IoSearchOutline className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-lg text-lightText" />
            <input
              value={searchUser}
              onChange={(e) => setsearchUser(e.target.value)}
              className="w-full rounded-[10px] border-0 bg-black/[0.06] py-2.5 pl-10 pr-10 text-[15px] text-darkText outline-none placeholder:text-lightText dark:bg-white/[0.1]"
              type="search"
              enterKeyHint="search"
              placeholder={translate("Search User")}
            />
            {searchUser.length > 0 && (
              <button
                type="button"
                aria-label="Clear"
                onClick={() => setsearchUser("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-lightText"
              >
                <RxCross2 className="text-lg" />
              </button>
            )}
          </div>
        </div>
      </div>

      <SelectedContact />

      <div
        className={`min-h-0 flex-1 overflow-y-auto px-4 pt-3 ${
          canContinue ? "pb-28" : "pb-10"
        }`}
      >
        <ContactList searchUser={searchUser} />
      </div>

      {canContinue && (
        <div className="absolute inset-x-0 bottom-0 border-t border-black/[0.06] bg-secondary/95 px-4 pb-[calc(1rem+env(safe-area-inset-bottom))] pt-3 backdrop-blur-xl dark:border-white/[0.08] lg:pb-4">
          <button
            type="button"
            onClick={() => navigate("/create-group")}
            className="w-full rounded-xl bg-themeColor py-3.5 text-center text-[17px] font-semibold text-themeTextColor transition active:scale-[0.99]"
          >
            <TextTranslate text="Next" />
          </button>
        </div>
      )}
    </div>
  );
}
